$(document).ready(function() {    
    const windowEl = $(window);
    const documentEl = $(document);

    // Sticky button
    $(function() {
        const button = $('.take-the-hair-test-wrapper');
        if (!button.length) return;

        const SHOW_AT = 400;        
        const HIDDEN_RIGHT = '-300px';

        let isVisible = false;
        let isTicking = false;

        const getRightValue = () => window.innerWidth < 565 ? '10px' : '30px';

        function updateVisibility() {
            const shouldShow = $(this).scrollTop() > SHOW_AT;
            if (shouldShow === isVisible) return;
            
            isVisible = shouldShow;
            button.stop(true).animate(
                shouldShow 
                ? { right: getRightValue(), opacity: 1 }
                : { right: '-300px', opacity: 0 },
                400
            );
        }
        windowEl.on('scroll resize', function() {
            if (!isTicking) {
                isTicking = true;
                requestAnimationFrame(function () {
                    updateVisibility();
                    isTicking = false;
                });
            }
        });
    });

    // Accordion click event
    documentEl.on('click', function(e) {
        const accordion = $(e.target).closest('.accordion');
        if (!accordion.length) return;

        const details = accordion.find('.js-accordion-details').get(0);
        const summary = accordion.find('summary');

        // Prevent native summary toggle
        if ($(e.target).closest('summary').length) {
            e.preventDefault();
        }

        // Toggle details when clicking anywhere in accordion
        details.open = !details.open;
    });

    function initSwiper(wrapperSelector, options) {
        $(wrapperSelector).each(function () {
            const swiperEl = $(this).find('.swiper');
            if (!swiperEl.length || swiperEl.hasClass('swiper-initialized')) return;
            new Swiper(swiperEl[0], options);
        });
    }

    initSwiper('.miul-testimonials-wrapper', {
        slidesPerView: 4,
        spaceBetween: 20,
        pagination: {
            el: '.miul-testimonials__pagination',
            clickable: true
        },
        breakpoints: {
            0: { slidesPerView: 1 },
            600: { slidesPerView: 2 },
            990: { slidesPerView: 3 },
            1200: { slidesPerView: 4 }
        }
    });
 
    initSwiper('.shop-by-concern-wrapper', {
        slidesPerView: 5,
        pagination: {
            el: '.shop-by-concern__pagination',
            clickable: true
        },
        breakpoints: {
            0: { slidesPerView: 2.3 },
            565: { slidesPerView: 3.3 },
            767: { slidesPerView: 4.3 },
            990: { slidesPerView: 5 }
        }
    });

    // Product page Accordion
    $(function() {
        $('.product-accordion-section').each(function() {

            let section = $(this);

            let firstItem = section.find('.accordion-item').first();
            let firstContent = firstItem.find('.accordion-content');
            let firstIcon = firstItem.find('.accordion-icon');

            firstItem.addClass('active');
            firstContent.css({
                'max-height': firstContent[0].scrollHeight + 'px',
                opacity: 1
            });
            firstIcon.text('–');

            section.find('.accordion-header').on('click', function(e) {
                e.preventDefault();

                const item = $(this).closest('.accordion-item');
                const content = item.find('.accordion-content');
                const icon = $(this).find('.accordion-icon');

                const isOpen = item.hasClass('active');

                // Close all in this section
                section.find('.accordion-item').removeClass('active');
                section.find('.accordion-content').css({
                    'max-height': 0,
                    opacity: 0
                });
                section.find('.accordion-icon').text('+');

                // Open clicked item
                if (!isOpen) {
                    item.addClass('active');
                    content.css({
                        'max-height': content[0].scrollHeight + 'px',
                        opacity: 1
                    });
                    icon.text('–');
                }
            });

        });

    });

    // Product page Accordion list type
    $(function() {
        $('.how-to-use-section').each(function() {

            let section = $(this);

            let firstItem = section.find('.accordion-item-step').first();
            let firstContent = firstItem.find('.accordion-content-step');
            let firstIcon = firstItem.find('.accordion-icon-step');

            firstItem.addClass('active');
            firstContent.css({
                'max-height': firstContent[0].scrollHeight + 'px',
                opacity: 1
            });
            firstIcon.text('–');

            section.find('.accordion-header-step').on('click', function(e) {
                e.preventDefault();

                const item = $(this).closest('.accordion-item-step');
                const content = item.find('.accordion-content-step');
                const icon = $(this).find('.accordion-icon-step');

                const isOpen = item.hasClass('active');

                // Close all in this section
                section.find('.accordion-item-step').removeClass('active');
                section.find('.accordion-content-step').css({
                    'max-height': 0,
                    opacity: 0
                });
                section.find('.accordion-icon-step').text('+');

                // Open clicked item
                if (!isOpen) {
                    item.addClass('active');
                    content.css({
                        'max-height': content[0].scrollHeight + 'px',
                        opacity: 1
                    });
                    icon.text('–');
                }
            });

        });

    });

    function togglePassword(button, input) {
        const isPassword = input.attr('type') === 'password';
        input.attr('type', isPassword ? 'text' : 'password');
        button.find('.pass-hide, .register-pass-hide, .register-confirm-hide').toggle(!isPassword);
        button.find('.pass-show, .register-pass-show, .register-confirm-show').toggle(isPassword);
    }

    documentEl.on('click', '.pass-svg', function () {
        togglePassword($(this), $('#CustomerPassword'));
    });

    documentEl.on('click', '.register-pass-svg', function () {
        togglePassword($(this), $('#RegisterForm-password'));
    });

    documentEl.on('click', '.register-confirm-svg', function () {
        togglePassword($(this), $('#RegisterForm-confirm-password'));
    });

    // login page password input 
    // $(document).on('click', '.pass-svg', function() {
    //     const input = $('#CustomerPassword');
    //     const wrapper = $(this);

    //     const isPassword = input.attr('type') === 'password';

    //     input.attr('type', isPassword ? 'text' : 'password');

    //     wrapper.find('.pass-hide').toggle(!isPassword);
    //     wrapper.find('.pass-show').toggle(isPassword);
    // });

    // // register page password input 
    // $(document).on('click', '.register-pass-svg', function() {
    //     const input = $('#RegisterForm-password');
    //     const wrapper = $(this);

    //     const isPassword = input.attr('type') === 'password';

    //     input.attr('type', isPassword ? 'text' : 'password');

    //     wrapper.find('.register-pass-hide').toggle(!isPassword);
    //     wrapper.find('.register-pass-show').toggle(isPassword);
    // });

    // // register page confirm password input 
    // $(document).on('click', '.register-confirm-svg', function() {
    //     const input = $('#RegisterForm-confirm-password');
    //     const wrapper = $(this);

    //     const isPassword = input.attr('type') === 'password';

    //     input.attr('type', isPassword ? 'text' : 'password');

    //     wrapper.find('.register-confirm-hide').toggle(!isPassword);
    //     wrapper.find('.register-confirm-show').toggle(isPassword);
    // });

    // Show / hide sticky bar on scroll
    (function() {
        const stickyBar = $('#StickyAddToCart');
        const productForm = $('form[action^="/cart/add"]').first();
        const hairTestBtn = $('.take-the-hair-test-wrapper');

        // 👉 If no Sticky ATC, EXIT (non-product pages)
        if (!stickyBar.length || !productForm.length) {
            $('html').css('--sticky-atc-height', '0px');
            return;
        }

        const triggerPoint = productForm.offset().top + productForm.outerHeight();
        // const triggerPoint = 400;

        $(window).on('scroll resize', function() {
            if ($(window).scrollTop() > triggerPoint) {
                stickyBar.addClass('show');

                const atcHeight = stickyBar.outerHeight();
                $('html').css('--sticky-atc-height', atcHeight + 'px');

                hairTestBtn.addClass('show');
            } else {
                stickyBar.removeClass('show');

                $('html').css('--sticky-atc-height', '0px');
                hairTestBtn.removeClass('show');
            }
        });

        // ADD TO CART → trigger Dawn button
        stickyBar.on('click', '[data-action="add-to-cart"]', function() {
            const addBtn = productForm.find('button[name="add"]').first();

            if (addBtn.length) {
                addBtn.trigger('click');
            }
        });

    })();

    // Discount code Logic
    (function() {
        if (window.cartDiscountReady) return;
        window.cartDiscountReady = true;

       document.addEventListener(
            'change',
            function (e) {
                if (
                    e.target.id === 'discount-code' ||
                    e.target.closest('.cart-discount')
                ) {
                    e.stopImmediatePropagation();
                }
            },
            true
        );
        function refreshCartDrawer() {
            const cartDrawer = document.querySelector('cart-drawer');
            if (!cartDrawer || typeof cartDrawer.renderContents !== 'function') return;

            const isCartPage = window.location.pathname === '/cart';

            const sections = cartDrawer
                .getSectionsToRender()
                .map(section => section.id)
                .join(',');

            fetch(`${routes.cart_url}?sections=${sections}`)
                .then(res => res.json())
                .then(data => {
                cartDrawer.suppressOpen = isCartPage; // 🔒 key line
                cartDrawer.renderContents({ sections: data });
                cartDrawer.suppressOpen = false;      // 🔓 reset
                });
        }


        function refreshCartPage() {
            const cartItems = document.querySelector('cart-items');
            if (!cartItems || !cartItems.getSectionsToRender) return;

            const sections = cartItems
                .getSectionsToRender()
                .map(s => s.section)
                .join(',');

            fetch(`${routes.cart_url}?sections=${sections}`)
                .then(response => response.json())
                .then(data => {
                    cartItems.getSectionsToRender().forEach(section => {
                        const root = document.getElementById(section.id);
                        if (!root || !data[section.section]) return;

                        const container = root.querySelector(section.selector) || root;

                        const html = new DOMParser()
                            .parseFromString(data[section.section], 'text/html')
                            .querySelector(section.selector)?.innerHTML;

                        if (html) container.innerHTML = html;
                    });
                });
        }

        function refreshCart() {
            // refreshCartDrawer();
            refreshCartPage();
        }

        // Apply discount
        documentEl.on('submit', '.cart-discount-form', function(e) {
            e.preventDefault();

            const input = $(this).find('[name="discount"]');
            const code = $.trim(input.val());
            if (!code) return;

            fetch('/cart/update.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ discount: code }),
            }).then(refreshCart);
        });

        // Remove discount
        documentEl.on('click', '.remove-discount', function (event) {
            event.preventDefault();

            fetch('/cart/update.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ discount: '' }),
            }).then(refreshCart);
        });
    })();

    // Mobile icon navigation show/hide on scroll
    (function () {
        const mobileNav = $('.mobile-icon-nav');
        if (!mobileNav.length) return; 

        let lastScrollTop = 0;
        const threshold = 80;

        $(window).on('scroll', function() {
            const currentScroll  = $(this).scrollTop();

            if ( currentScroll  > threshold) {
                mobileNav.addClass('is-visible');

                const navHeight = mobileNav.outerHeight();
                document.documentElement.style.setProperty(
                    '--mobile-nav-height',
                    navHeight + 'px'
                );
            } else {
                mobileNav.removeClass('is-visible');
                document.documentElement.style.setProperty(
                    '--mobile-nav-height',
                    '0px'
                );
            }
            lastScrollTop = currentScroll  <= 0 ? 0 : currentScroll;
        });
    })();
});

document.addEventListener('DOMContentLoaded', function () {
  const cartIcon = document.getElementById('cart-icon-bubble');
  if (!cartIcon) return;

  const isCartPage = window.location.pathname === '/cart';

  if (isCartPage) {
    // Remove Dawn drawer behavior on cart page
    cartIcon.addEventListener(
      'click',
      function (e) {
        // allow normal navigation to /cart
        e.stopImmediatePropagation();
        // do NOT preventDefault
      },
      true // capture phase (important)
    );
  }
});

// Sync Sticky Quantity Start
(() => {
  let isSyncing = false;

  const SELECTOR = '.sync-quantity input';

  function clamp(value, input) {
    const min = parseInt(input.getAttribute('min')) || 1;
    const max = parseInt(input.getAttribute('max')) || Infinity;
    const step = parseInt(input.getAttribute('step')) || 1;

    value = parseInt(value) || min;

    value = Math.max(min, Math.min(max, value));
    value = Math.round(value / step) * step;

    return value;
  }

  function getInputs() {
    return document.querySelectorAll(SELECTOR);
  }

  function syncAll(sourceInput, value) {
    if (isSyncing) return;
    isSyncing = true;

    const inputs = getInputs();

    inputs.forEach(input => {
      if (input === sourceInput) return;

      const newValue = clamp(value, input);

      if (parseInt(input.value) !== newValue) {
        input.value = newValue;

        // Dawn listens to change event
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });

    isSyncing = false;
  }

  function bindInput(input) {
    if (input.dataset.syncBound) return;
    input.dataset.syncBound = 'true';

    const handler = (e) => {
      const val = clamp(e.target.value, e.target);
      e.target.value = val;
      syncAll(e.target, val);
    };

    input.addEventListener('input', handler);
    input.addEventListener('change', handler);
  }

  function init() {
    const inputs = getInputs();
    if (!inputs.length) return;

    inputs.forEach(bindInput);

    // Initial sync (use first visible input)
    const first = inputs[0];
    const initialValue = clamp(first.value, first);
    syncAll(first, initialValue);
  }

  // ✅ Dawn: runs when product section reloads
  document.addEventListener('shopify:section:load', init);

  // ✅ Dawn: variant change triggers section re-render
  document.addEventListener('variant:change', () => {
    setTimeout(init, 50);
  });

  // Initial load
  document.addEventListener('DOMContentLoaded', init);

  // ✅ Sticky ATC appears dynamically → observe DOM
  const observer = new MutationObserver(() => {
    init();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

})();
// Sync Sticky Quantity End